var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"album"}},[_c('div',{staticClass:"photography-section"},[_c('h1',[_vm._v("Album")]),_c('div',{staticClass:"masonry"},_vm._l((_vm.photos),function(photo,index){return _c('img',{key:index,attrs:{"src":_vm.getImageUrl(photo),"alt":'Photo ' + (index + 1)}})}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }